import { CngTileEffect, TileId } from '@contact/upgrade';

export abstract class CngHistoryEffect extends CngTileEffect {
  constructor() {
    super(TileId.HISTORIZATION);
  }
}
